// mutation-types.js
const SOCKET_ONOPEN = 'SOCKET_ONOPEN '
const SOCKET_ONCLOSE = 'SOCKET_ONCLOSE'
const SOCKET_ONERROR= 'SOCKET_ONERROR'
const SOCKET_ONMESSAGE = 'SOCKET_ONMESSAGE'
const SOCKET_RECONNECT = 'SOCKET_RECONNECT'
const SOCKET_RECONNECT_ERROR = 'SOCKET_RECONNECT_ERROR'
 
export {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
}
 


// WEBPACK FOOTER //
// ./src/mutationTypes.js